





























































































































































































import DetailsTable from '@/components/reports/DetailsTable.vue';
import StackedColumnGraph from '@/components/reports/StackedColumnGraph.vue';

export default {
    name: 'TrademarkDetails',
    components: { DetailsTable, StackedColumnGraph },
    props: {
        dataSource: {},
        isTrademark: {},
        normalizeData: {},
        shouldShowValue: {},
        singleRecordData: {},
        trademarkRelationData: {},
    },
};
